"use client";

import { Genres } from "@/components/_types/genres";
import { trackClick } from "@/components/util/functions";
import Link from "next/link";
import { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";

const navItems = [
	{ name: "کات من", link: "/dashboard", onClickTrack: false },
	{ name: "اخبار", link: "/news", onClickTrack: true },
	{
		name: "بازی",
		link: "/games/categories",
		dropdown: true,
		key: "games",
		onClickTrack: true,
		submenuItems: [
			{
				name: "ژانرها",
				itemsKey: "games",
				link: "/games/genres",
				linkBase: "/games/genres",
			},
			{
				name: "دسته بندی ها",
				itemsKey: "games",
				link: "/games/categories",
				linkBase: "/games/categories",
			},
		],
	},
	{
		name: "فیلم",
		link: "/movies/categories",
		dropdown: true,
		key: "movies",
		onClickTrack: true,
		submenuItems: [
			{
				name: "ژانرها",
				itemsKey: "movies",
				link: "/movies/genres",
				linkBase: "/movies/genres",
			},
			{
				name: "دسته بندی ها",
				itemsKey: "movies",
				link: "/movies/categories",
				linkBase: "/movies/categories",
			},
		],
	},
	{
		name: "سریال",
		link: "/series/categories",
		dropdown: true,
		key: "series",
		onClickTrack: true,
		submenuItems: [
			{
				name: "ژانرها",
				itemsKey: "series",
				link: "/series/genres",
				linkBase: "/series/genres",
			},
			{
				name: "دسته بندی ها",
				itemsKey: "series",
				link: "/series/categories",
				linkBase: "/series/categories",
			},
		],
	},
	{
		name: "بازی رومیزی",
		link: "/board-games/categories",
		dropdown: true,
		key: "boardGames",
		onClickTrack: true,
		submenuItems: [
			{
				name: "ژانرها",
				itemsKey: "boardGames",
				link: "/board-games/genres",
				linkBase: "/board-games/genres",
			},
			{
				name: "دسته بندی ها",
				itemsKey: "boardGames",
				link: "/board-games/categories",
				linkBase: "/board-games/categories",
			},
		],
	},
];

const MobileDrawer = ({
	isOpen,
	toggleDrawer,
	genres,
	categories,
}: {
	isOpen: boolean;
	toggleDrawer: any;
	genres: Genres;
	categories: Genres;
}) => {
	const [openDropdowns, setOpenDropdowns] = useState({});

	const handleDropdownToggle = (key: string) => {
		setOpenDropdowns((prev) => ({
			...prev,
			[key]: !prev[key as keyof typeof prev],
		}));
	};

	const getItems = (itemsKey: keyof Genres, submenuName: string) => {
		if (submenuName.includes("ژانرها")) {
			return genres[itemsKey];
		}
		return categories[itemsKey];
	};

	return (
		<>
			{isOpen && (
				<div
					className="fixed inset-0 bg-black bg-opacity-50 z-40"
					onClick={toggleDrawer}
				></div>
			)}
			<div
				className={`fixed top-0 left-0 h-full w-64 p-4 z-50 transform transition-transform duration-300 ease-in-out overflow-y-auto ${
					isOpen ? "translate-x-0" : "-translate-x-full"
				} bg-gray-900 text-white shadow-lg`}
			>
				<div className="flex justify-between items-center mb-6">
					<h2 className="text-xl font-semibold">منو</h2>
					<button
						onClick={toggleDrawer}
						className="text-gray-400 hover:text-white"
					>
						<IoMdClose size={24} />
					</button>
				</div>
				<ul className="space-y-4">
					{navItems.map((item, index) => (
						<li key={index}>
							{item.dropdown ? (
								<div className="flex flex-col">
									<button
										onClick={() => handleDropdownToggle(item.key)}
										className="flex items-center justify-between w-full text-left py-2 hover:text-gray-400"
									>
										<span>{item.name}</span>
										<FaChevronDown
											size={12}
											className={`transform transition-transform duration-200 ${
												openDropdowns[item.key as keyof typeof openDropdowns]
													? "rotate-180"
													: "rotate-0"
											}`}
										/>
									</button>
									{openDropdowns[item.key as keyof typeof openDropdowns] && (
										<ul className="pl-4 mt-2 space-y-2">
											{item.submenuItems.map((submenu, subIndex) => (
												<li key={subIndex} className="flex flex-col">
													<button
														onClick={() =>
															handleDropdownToggle(item.key + subIndex)
														}
														className="flex items-center justify-between w-full text-left py-2 hover:text-gray-400"
													>
														<span>{submenu.name}</span>
														<FaChevronDown
															size={12}
															className={`transform transition-transform duration-200 ${
																openDropdowns[
																	(item.key +
																		subIndex) as keyof typeof openDropdowns
																]
																	? "rotate-180"
																	: "rotate-0"
															}`}
														/>
													</button>
													{openDropdowns[
														(item.key + subIndex) as keyof typeof openDropdowns
													] && (
														<ul className="pl-4 mt-2 space-y-2">
															{getItems(
																submenu.itemsKey as keyof Genres,
																submenu.name
															).map((genre, genreIndex) => (
																<li key={genreIndex}>
																	<Link
																		href={`${submenu.linkBase}/${genre.id}`}
																		className="block py-2 hover:text-gray-400"
																		onClick={() => {
																			toggleDrawer();
																			if (item.onClickTrack) {
																				trackClick(item.link);
																			}
																		}}
																	>
																		{genre.persianName}
																	</Link>
																</li>
															))}
															<li>
																<Link
																	href={submenu.linkBase}
																	className="block py-2 hover:text-gray-400"
																	onClick={() => {
																		toggleDrawer();
																		if (item.onClickTrack) {
																			trackClick(item.link);
																		}
																	}}
																>
																	همه {submenu?.name}
																</Link>
															</li>
														</ul>
													)}
												</li>
											))}
										</ul>
									)}
								</div>
							) : (
								<Link href={item.link} className="block">
									<span
										className="py-2 block hover:text-gray-400"
										onClick={() => {
											toggleDrawer();
											if (item.onClickTrack) {
												trackClick(item.link);
											}
										}}
									>
										{item.name}
									</span>
								</Link>
							)}
						</li>
					))}
				</ul>
			</div>
		</>
	);
};

export default MobileDrawer;
